import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { money, shortDate } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function TripDetail() {
  const { id } = useParams();
  const [trip, setTrip] = useState(null);
  const [perf, setPerf] = useState(null);
  const [visits, setVisits] = useState([]);
  useEffect(() => {
    api.get(`/trips/${id}`).then(r => setTrip(r.data));
    api.get(`/trips/${id}/performance`).then(r => setPerf(r.data));
    api.get(`/visits`, { params: { trip_id: id } }).then(r => setVisits(r.data));
  }, [id]);
  if (!trip || !perf) return <div>Loading…</div>;
  const kpi = (label, value) => (
    <div className="bg-white rounded-xl border border-slate-200 p-5"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{label}</div><div className="kpi-value text-3xl mt-2">{value}</div></div>
  );
  return (
    <div className="space-y-6" data-testid="trip-detail-page">
      <Link to="/trips" className="inline-flex items-center gap-2 text-sm text-slate-500"><ArrowLeft className="w-4 h-4" /> Back</Link>
      <div>
        <h1 className="text-3xl font-heading font-black">{trip.name}</h1>
        <p className="text-slate-600">{trip.town}, {trip.state} • {shortDate(trip.start_date)} – {shortDate(trip.end_date)} • Agent: {trip.agent_name}</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {kpi("Stores Visited", perf.stores_visited)}
        {kpi("Sales Before Visit", money(perf.sales_before))}
        {kpi("Sales During Trip Month", money(perf.sales_during_month))}
        {kpi("Sales After Visit (30d)", money(perf.sales_after_visit_total))}
        {kpi("Orders Received (7d)", perf.orders_7d)}
        {kpi("Orders Received (14d)", perf.orders_14d)}
        {kpi("Orders Received (30d)", perf.orders_30d)}
        {kpi("Est. Opportunity Value", money(perf.estimated_opportunity_value))}
        {kpi("New Customers", perf.new_customers)}
        {kpi("Recovered Customers", perf.recovered_customers)}
        {kpi("Completed Follow-ups", perf.completed_followups)}
        {kpi("Trip Expenses", money(trip.expenses))}
      </div>
      <p className="text-xs text-slate-500 italic">Note: sales after visit are correlated observations, not attributed directly to the agent visit.</p>
      <div className="bg-white rounded-xl border border-slate-200 p-5">
        <h3 className="text-lg font-heading font-semibold mb-3">Visits on this Trip</h3>
        <ul className="divide-y divide-slate-100">
          {visits.map(v => (
            <li key={v.id} className="py-2 flex justify-between text-sm">
              <div><div className="font-medium">{v.customer_name}</div><div className="text-xs text-slate-500">{shortDate(v.visit_date)} • {v.visit_purpose}</div></div>
              <div className="text-xs">{money(v.estimated_opportunity_value)}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
